import { render, staticRenderFns } from "./FulfillmentAttachmentFile.vue?vue&type=template&id=4d9aa719&scoped=true"
import script from "./FulfillmentAttachmentFile.vue?vue&type=script&lang=js"
export * from "./FulfillmentAttachmentFile.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentAttachmentFile.vue?vue&type=style&index=0&id=4d9aa719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9aa719",
  null
  
)

export default component.exports